import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled(Typography.Body).attrs(() => ({
  $variant: '1',
}))`
  padding: 15px;
  background-color: ${({ theme }) => theme.palette.tertiary.background};
  color: ${({ theme }) => theme.palette.primary.labels};
`;
